import LocalizedDateTimePicker from 'lib/LocalizedDateTimePicker'
import {EnabledSwitch} from 'lib/ui/form/Switch'
import TextField from 'lib/ui/TextField'
import {Label} from 'lib/ui/typography'
import React from 'react'
import {Controller, UseFormMethods} from 'react-hook-form'
import {Agenda} from 'Event/template/Cards/Dashboard/Sidebar/SidebarItem/AgendaList'
import {onChangeCheckedHandler, onChangeDate} from 'lib/dom'
import {useAttendeeVariables} from 'Event'
import {startOfMinute} from 'date-fns'

export default function Settings(props: {
  control: UseFormMethods['control']
  agenda: Agenda
  watch: UseFormMethods['watch']
  errors: UseFormMethods['errors']
}) {
  const {agenda, watch, control, errors} = props

  const v = useAttendeeVariables()
  const startDate = watch('startDate', agenda.startDate)

  return (
    <>
      <Controller
        name="isVisible"
        defaultValue={agenda.isVisible}
        control={control}
        render={({value, onChange}) => (
          <EnabledSwitch
            checked={value}
            onChange={onChangeCheckedHandler(onChange)}
          />
        )}
      />
      <Label>Text</Label>
      <Controller
        name="text"
        defaultValue={v(agenda.text)}
        control={control}
        render={({value, onChange}) => (
          <TextField
            aria-label="agenda text"
            fullWidth
            value={value}
            onChange={onChange}
          />
        )}
      />
      <Controller
        name="startDate"
        control={control}
        defaultValue={agenda.startDate}
        render={({value, onChange}) => {
          return (
            <LocalizedDateTimePicker
              value={value}
              onClear={() => {
                onChange(null)
              }}
              onChange={onChangeDate(onChange)}
              fullWidth
              label="Start"
              minDate={new Date()}
              inputProps={{
                'aria-label': 'agenda start date',
              }}
            />
          )
        }}
      />
      <Controller
        name="endDate"
        control={control}
        defaultValue={agenda.endDate}
        rules={{
          validate: {
            notBeforeStart: (value) =>
              !value ||
              !startDate ||
              startOfMinute(new Date(value)) >=
                startOfMinute(new Date(startDate)) ||
              'End date must be after start date',
          },
        }}
        render={({value, onChange}) => (
          <LocalizedDateTimePicker
            value={value}
            onClear={() => {
              onChange(null)
            }}
            onChange={onChangeDate(onChange)}
            fullWidth
            label="End"
            inputProps={{
              'aria-label': 'agenda end date',
            }}
            error={Boolean(errors.endDate?.message)}
            helperText={errors.endDate?.message}
          />
        )}
      />
      <Label>Agenda Link</Label>
      <Controller
        name="link"
        defaultValue={v(agenda.link ?? '')}
        control={control}
        render={({value, onChange}) => (
          <TextField
            aria-label="agenda link"
            fullWidth
            value={value}
            onChange={onChange}
          />
        )}
      />
    </>
  )
}
